<template>
  <div :class="componentClasses">
    <Icon
      v-if="icon"
      class="stk-box-head-icon"
      :icon="icon"
    />
    <p class="stk-box-head-title">
      <slot />
    </p>

    <div class="stk-box-head-right">
      <router-link
        v-if="link.to"
        :to="link.to"
        class="stk-box-head-link"
      >
        {{ link.label }}
      </router-link>

      <slot name="right" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@stakeui/graphic/icon/Icon.vue';

defineProps({
  icon: {
    type: String,
    default: '',
  },
  link: {
    type: Object,
    default: () => ({}),
  },
});

const componentClasses = computed(() => [
  'stk-box-head',
]);
</script>

<style>
.stk-box-head {
  align-items: center;
  display: flex;
  gap: 0.5rem;
}

.stk-box-head-icon {
  color: var(--stk-primary);
}

.stk-box-head-title {
  color: var(--stk-text-strong);
  font-size: 1.125em;
  font-weight: 600;
  line-height: 1.25;
}

.stk-box-head-right {
  display: flex;
  align-items: center;
  gap: 1em;
  font-size: 0.875em;
  margin-left: auto;
}
</style>
